import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-list-wrap" }

import BoardNavbar from "@/views/product/testing/Navbar.vue";
import PUTT_Items from "@/views/product/testing/PUTT_Items.vue";
import Banner from "@/components/Banner.vue";

import { USER_ROUTES } from "@/assets/route_constants.ts";

export default /*@__PURE__*/_defineComponent({
  __name: 'PUTT',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Banner, {
      title: "진단검사",
      subtitle: "진단검사",
      description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    }),
    _createVNode(BoardNavbar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "sub_subject" }, "PUTT2.0 다중재능검사", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(PUTT_Items)
        ])
      ])
    ])
  ]))
}
}

})